
import eyeShowUrl from './icons/eye-show.svg';
import eyeShowPrimaryUrl from './icons/eye-show-primary.svg';
import eyeHideUrl from './icons/eye-hide.svg';
import arrowLeftUrl from './icons/arrow-left.svg';
import envelopeUrl from './icons/envelope.svg';
import checkCircleUrl from './icons/check-circle.svg';
import shieldCheckUrl from './icons/shield-check.svg';
import infoCircleUrl from './icons/info-circle.svg';
import calendarUrl from './icons/calendar.svg';
import clearUrl from './icons/clear.svg';
import alertUrl from './icons/alert.svg';
import usersUrl from './icons/users.svg';
import downarrowUrl from './icons/down-arrow.svg';
import deleteUrl from './icons/delete.svg';
import plusgreyUrl from './icons/plus-grey.svg';
import minusUrl from './icons/minus.svg';
import downloadUrl from './icons/download.svg';
import downloadgreyUrl from './icons/download-grey.svg';
import linkedinUrl from './icons/linkedin.svg';
import twitterUrl from './icons/twitter.svg';
import instagramUrl from './icons/instagram.svg';

// ─── Sidebar Icons ─────────────────────────────────────────────────
import sidebarDashboardUrl from './icons/sidebar-dashboard.svg';
import sidebarDealersUrl from './icons/sidebar-dealers.svg';
import sidebarUsersUrl from './icons/sidebar-users.svg';
import sidebarAuditsUrl from './icons/sidebar-audits.svg';
import sidebarAuditTypesUrl from './icons/sidebar-audit-types.svg';
import sidebarDepartmentsUrl from './icons/sidebar-departments.svg';
import sidebarSectionUrl from './icons/sidebar-section.svg';
import sidebarQuestionUrl from './icons/sidebar-question.svg';
import sidebarReferenceDocsUrl from './icons/sidebar-reference-docs.svg';
import sidebarReportsUrl from './icons/sidebar-reports.svg';
import sidebarRolesUrl from './icons/sidebar-roles.svg';

// ─── Summary Card Icons ───────────────────────────────────────────────────
import cardTotalUsersUrl from './icons/card-total-users.svg';
import cardAdminUrl from './icons/card-admin.svg';
import cardActiveUrl from './icons/card-active.svg';
import cardAuditorsUrl from './icons/card-auditors.svg';
import cardTotalAuditUrl from './icons/card-total-audit.svg';
import cardInProgressUrl from './icons/card-in-progress.svg';
import cardCompletedUrl from './icons/card-completed.svg';
import cardOverdueUrl from './icons/card-overdue.svg';
import cardTotalDealerUrl from './icons/card-total-dealer.svg';

// ─── UI / Action Icons ───────────────────────────────────────────────────
import searchUrl from './icons/search.svg';
import plusUrl from './icons/plus.svg';
import importUrl from './icons/import.svg';
import importblueUrl from './icons/import-blue.svg';
import exportUrl from './icons/export.svg';
import dotsHorizontalUrl from './icons/dots-horizontal.svg';
import chevronRightUrl from './icons/chevron-right.svg';
import chevronLeftUrl from './icons/chevron-left.svg';
import sortAscUrl from './icons/sort-asc.svg';
import sortDescUrl from './icons/sort-desc.svg';
import editPenUrl from './icons/edit-pen.svg';
import editIcon from './icons/edit.svg';
import duplicateUrl from './icons/duplicate.svg';
import modalCloseUrl from './icons/model-close-button.svg';
import formSectionUrl from './icons/form-section.svg';
import fileUploadUrl from './icons/file-upload.svg';
import checkboxCheckUrl from './icons/checkbox-check.svg';
import menuUrl from './icons/menu.svg';
import bellUrl from './icons/bell.svg';
import schduleCalender from './icons/schdule-calendar.svg';
import auditquestiondesign from './icons/audit-question.svg';
import teamassignemet from './icons/team-assignemet.svg';
import classificationicon from './icons/classification.svg';
import chevronDownUrl from './icons/chevron-down.svg';
import uploadExportUrl from './icons/upload-export.svg';
import filterUrl from './icons/filter.svg';
import closeCircleUrl from './icons/close-circle.svg';
import verctorIcon from './icons/vector.svg';
import closeIcon from './icons/close.svg';
import logoUrl from './svg/logo.svg';
import logosmUrl from './svg/logo-sm.svg';
import sidebarLogoUrl from './svg/sidebarlogo.svg';
import illustrationUrl from './svg/authleftpanel.svg';
import linesUrl from './svg/lines.svg';



import authLeftImgUrl from './image/authLeftImg.png';
import heroStudentsUrl from './image/hero-students.jpg';
import iagImgUrl from './image/iag_clean.png';
import onembillionImgUrl from './image/onembillion_clean.png';
import tpaLogoImgUrl from './image/tpa-logo.png';
import tpaScrollLogoUrl from './image/tpalogscroller.png'
import tpaImgUrl from './image/tpa.jpg';
import tpaRealLogoUrl from './image/tpa_real_logo.png';
import tpaFullBrandLogoUrl from './image/tpa_full_brand_logo.png';

// ─── Coding-Dog Mascot (Student Journey) ─────────────────────────────────
// Processed from src/assets/animatedicon/*.png (raw ~14 MB) → optimized WebP,
// two responsive widths each (`sm` ≈ 512px, `lg` ≈ 960px). See MASCOT_META
// below for per-asset transparency / usage notes.
import mascotCodingSm from './mascots/mascot-coding-sm.webp';
import mascotCodingLg from './mascots/mascot-coding-lg.webp';
import mascotUnlockSm from './mascots/mascot-unlock-sm.webp';
import mascotUnlockLg from './mascots/mascot-unlock-lg.webp';
import mascotChecklistSm from './mascots/mascot-checklist-sm.webp';
import mascotChecklistLg from './mascots/mascot-checklist-lg.webp';
import poseCodingSm from './mascots/pose-coding-sm.webp';
import poseCodingLg from './mascots/pose-coding-lg.webp';
import poseStudiousSm from './mascots/pose-studious-sm.webp';
import poseStudiousLg from './mascots/pose-studious-lg.webp';
import poseCelebrateSm from './mascots/pose-celebrate-sm.webp';
import poseCelebrateLg from './mascots/pose-celebrate-lg.webp';
import poseTerminalSm from './mascots/pose-terminal-sm.webp';
import poseTerminalLg from './mascots/pose-terminal-lg.webp';
import sceneKeepLearningSm from './mascots/scene-keep-learning-sm.webp';
import sceneKeepLearningLg from './mascots/scene-keep-learning-lg.webp';
import sceneThumbsUpSm from './mascots/scene-thumbs-up-sm.webp';
import sceneThumbsUpLg from './mascots/scene-thumbs-up-lg.webp';
import sceneDoingGreatSm from './mascots/scene-doing-great-sm.webp';
import sceneDoingGreatLg from './mascots/scene-doing-great-lg.webp';
import sceneLearnCreateGrowSm from './mascots/scene-learn-create-grow-sm.webp';
import sceneLearnCreateGrowLg from './mascots/scene-learn-create-grow-lg.webp';

export const Icons = {
    eyeShow: eyeShowUrl,
    /** Same glyph as `eyeShow`; fill `#017DF2` for primary/action styling (e.g. audit row actions). */
    eyeShowPrimary: eyeShowPrimaryUrl,
    eyeHide: eyeHideUrl,
    arrowLeft: arrowLeftUrl,
    envelope: envelopeUrl,
    checkCircle: checkCircleUrl,
    shieldCheck: shieldCheckUrl,
    infoCircle: infoCircleUrl,
    calendar: calendarUrl,
    schdulecalender:schduleCalender,
    auditquestiondesign:auditquestiondesign,
    teamassignemeticon:teamassignemet,
    classificationicon:classificationicon,
    clear: clearUrl,
    alert: alertUrl,
    users: usersUrl,
    downarrow: downarrowUrl,
    delete: deleteUrl,
    plusgrey: plusgreyUrl,
    minus : minusUrl,
    download : downloadUrl,
    downloadgrey : downloadgreyUrl,
    // Sidebar icons
    sidebarDashboard: sidebarDashboardUrl,
    sidebarDealers: sidebarDealersUrl,
    sidebarUsers: sidebarUsersUrl,
    sidebarAudits: sidebarAuditsUrl,
    sidebarAuditTypes: sidebarAuditTypesUrl,
    sidebarDepartments: sidebarDepartmentsUrl,
    sidebarSection: sidebarSectionUrl,
    sidebarQuestion: sidebarQuestionUrl,
    sidebarReferenceDocs: sidebarReferenceDocsUrl,
    sidebarReports: sidebarReportsUrl,
    sidebarRoles: sidebarRolesUrl,
    // Summary card icons
    cardTotalUsers: cardTotalUsersUrl,
    cardAdmin: cardAdminUrl,
    cardActive: cardActiveUrl,
    cardAuditors: cardAuditorsUrl,
    cardTotalAudit: cardTotalAuditUrl,
    cardInProgress: cardInProgressUrl,
    cardCompleted: cardCompletedUrl,
    cardOverdue: cardOverdueUrl,
    cardTotalDealer: cardTotalDealerUrl,
    // UI / action icons
    search: searchUrl,
    plus: plusUrl,
    import: importUrl,
    importblue: importblueUrl,
    export: exportUrl,
    dotsHorizontal: dotsHorizontalUrl,
    chevronRight: chevronRightUrl,
    chevronLeft: chevronLeftUrl,
    sortAsc: sortAscUrl,
    sortDesc: sortDescUrl,
    editPen: editPenUrl,
    filter: filterUrl,
    modalClose: modalCloseUrl,
    formSection: formSectionUrl,
    fileUpload: fileUploadUrl,
    checkboxCheck: checkboxCheckUrl,
    menu: menuUrl,
    bell: bellUrl,
    chevronDown: chevronDownUrl,
    uploadExport: uploadExportUrl,
    closeCircle: closeCircleUrl,
    edit:editIcon,
    duplicate: duplicateUrl,
    vector:verctorIcon,
    close:closeIcon,
    linkedin: linkedinUrl,
    twitter: twitterUrl,
    instagram: instagramUrl
} as const;

export const Svgs = {
    logo: logoUrl,
    logosm: logosmUrl,
    sidebarLogo: sidebarLogoUrl,
    illustration: illustrationUrl,
    lines: linesUrl,


} as const;

export const Images = {
    authLeftImg: authLeftImgUrl,
    heroStudents: heroStudentsUrl,
    iag: iagImgUrl,
    onembillion: onembillionImgUrl,
    tpaLogo: tpaLogoImgUrl,
    tpalogscroller:tpaScrollLogoUrl,
    tpa: tpaImgUrl,
    tpaRealLogo: tpaRealLogoUrl,
    tpaFullBrandLogo: tpaFullBrandLogoUrl,
} as const;

/**
 * Coding-dog mascot assets for the new Student Journey (Cohort 2+).
 * Each entry is `{ sm, lg }` responsive WebP. Prefer the `<Mascot>` component
 * (added in a later phase) over referencing these URLs directly.
 */
export const Mascots = {
    /** Puppy lying down, coding at a laptop. Transparent cutout. */
    coding: { sm: mascotCodingSm, lg: mascotCodingLg },
    /** Puppy jumping, "New Skill Unlocked!" badge + lightbulb. Transparent cutout. */
    unlock: { sm: mascotUnlockSm, lg: mascotUnlockLg },
    /** Puppy fist-pump beside a "New Concepts / Practice / Solve / Better" checklist. Transparent cutout. */
    checklist: { sm: mascotChecklistSm, lg: mascotChecklistLg },
    /** Pose sprite — hunched over a laptop. Transparent. */
    poseCoding: { sm: poseCodingSm, lg: poseCodingLg },
    /** Pose sprite — adjusting glasses, studious. Transparent. */
    poseStudious: { sm: poseStudiousSm, lg: poseStudiousLg },
    /** Pose sprite — arms up, green check, confetti. Transparent. */
    poseCelebrate: { sm: poseCelebrateSm, lg: poseCelebrateLg },
    /** Pose sprite — sitting beside a terminal window. Transparent. */
    poseTerminal: { sm: poseTerminalSm, lg: poseTerminalLg },
    /** Full illustrated desk scene, "Keep Learning" (baked text). Use as a bordered panel. */
    sceneKeepLearning: { sm: sceneKeepLearningSm, lg: sceneKeepLearningLg },
    /** Full illustrated scene, thumbs-up + "Learn / Practice / Solve / Grow" (baked text). */
    sceneThumbsUp: { sm: sceneThumbsUpSm, lg: sceneThumbsUpLg },
    /** Full illustrated scene, "You're Doing Great!" + Learn→Build→Grow (baked text). */
    sceneDoingGreat: { sm: sceneDoingGreatSm, lg: sceneDoingGreatLg },
    /** Full illustrated scene, "Learn Code Create Grow" + while(learning) snippet (baked text). */
    sceneLearnCreateGrow: { sm: sceneLearnCreateGrowSm, lg: sceneLearnCreateGrowLg },
} as const;

export type MascotKey = keyof typeof Mascots;

/**
 * Per-mascot metadata for the future `<Mascot>` component: whether the art has a
 * transparent background (safe on any surface) vs. a baked scene (panel only),
 * plus the journey states each asset suits best.
 */
export const MASCOT_META: Record<MascotKey, {
    transparent: boolean;
    kind: 'cutout' | 'pose' | 'scene';
    hasBakedText: boolean;
    uses: string[];
}> = {
    coding:        { transparent: true,  kind: 'cutout', hasBakedText: false, uses: ['loading', 'lab-boot', 'empty-coding'] },
    unlock:        { transparent: true,  kind: 'cutout', hasBakedText: false, uses: ['achievement', 'milestone-unlock', 'week-complete'] },
    checklist:     { transparent: true,  kind: 'cutout', hasBakedText: true,  uses: ['week-overview', 'onboarding'] },
    poseCoding:    { transparent: true,  kind: 'pose',   hasBakedText: false, uses: ['in-progress', 'idle', 'nav-empty'] },
    poseStudious:  { transparent: true,  kind: 'pose',   hasBakedText: false, uses: ['reading', 'tip', 'hint'] },
    poseCelebrate: { transparent: true,  kind: 'pose',   hasBakedText: false, uses: ['success', 'task-solved', 'streak'] },
    poseTerminal:  { transparent: true,  kind: 'pose',   hasBakedText: false, uses: ['coding-idle', 'lab-idle'] },
    sceneKeepLearning:    { transparent: false, kind: 'scene', hasBakedText: true, uses: ['home-hero', 'onboarding'] },
    sceneThumbsUp:        { transparent: false, kind: 'scene', hasBakedText: true, uses: ['home-hero', 'encouragement'] },
    sceneDoingGreat:      { transparent: false, kind: 'scene', hasBakedText: true, uses: ['mid-journey', 'progress'] },
    sceneLearnCreateGrow: { transparent: false, kind: 'scene', hasBakedText: true, uses: ['coding-intro', 'module-intro'] },
};